import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import logoDePulso from './pulso-logo.webp';
import simboloDePulso from './pulso-simbolo.webp';
import { FIRMA_DE_PULSO, PULSO } from './identidad';

/**
 * Logotipo completo de Pulso (simbolo, nombre y «by gelux»). Es claro sobre
 * transparente: solo se pone sobre el armazon de la marca, nunca sobre papel.
 */
export function LogoDePulso({ ancho = 220 }: { ancho?: number }) {
  return (
    <Box
      component="img"
      src={logoDePulso}
      alt={FIRMA_DE_PULSO}
      width={ancho}
      sx={{ display: 'block', width: ancho, maxWidth: '100%', height: 'auto' }}
    />
  );
}

/**
 * Firma del producto: el simbolo en su ficha nocturna y «Pulso by Gelux». Va en
 * el pie de la barra lateral y del portal, para que cada pantalla diga de que
 * familia es sin quitarle el protagonismo al consultorio.
 */
export function FirmaDePulso({ rotulo }: { rotulo?: string }) {
  return (
    <Stack direction="row" alignItems="center" sx={{ gap: 'var(--space-3)', minWidth: 0 }}>
      <Box
        component="img"
        src={simboloDePulso}
        // El nombre va escrito al lado: leerlo dos veces molesta.
        alt=""
        width={28}
        height={28}
        sx={{
          flexShrink: 0,
          borderRadius: 'var(--radius-sm)',
          boxShadow: '0 0 0 1px var(--bg-on-brand-overlay)',
        }}
      />
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component="span"
          sx={{
            display: 'block',
            fontFamily: 'var(--font-head)',
            fontSize: 'var(--text-body-dense)',
            fontWeight: 600,
            lineHeight: 'var(--leading-snug)',
            color: 'var(--text-primary)',
          }}
        >
          {PULSO.nombre}{' '}
          <Box component="span" sx={{ fontWeight: 400, color: 'var(--text-secondary)' }}>
            {PULSO.fabricante}
          </Box>
        </Typography>
        {rotulo && (
          <Typography
            component="span"
            noWrap
            sx={{ display: 'block', fontSize: 'var(--text-meta)', color: 'var(--text-tertiary)' }}
          >
            {rotulo}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
